const zh = {
    userName: "用户名",
    reg_phone: "手机号",
    reg_phone_hint: "请输入手机号",
    reg_phone_hint_two: "请输入正确的手机号!",
    reg_phone_hint_three: "手机号已经注册,可以直接登录!",
    reg_phone_hint_four: "手机认证有效，注册成功后可通过该手机登录和找回密码",
    reg_phone_hint_five: "该手机号未注册，请您先注册",
    reg_email: "邮箱",
    reg_email_hint: "请输入邮箱",
    reg_email_hint1: "请输入注册的邮箱",
    reg_email_hint_two: "请输入正确的邮箱!",
    reg_email_hint_three: "邮箱已经注册,可以直接登录!",
    reg_email_hint_four: "邮箱认证有效，注册成功后可通过该邮箱登录和找回密码",
    reg_email_hint_five: "该邮箱未注册，请您先注册",
    reg_code: "验证码",
    reg_code_hint: "请输入验证码",
    reg_phone_code: "手机验证码",
    reg_phone_code_hint: "请输入手机验证码",
    reg_email_code: "邮箱验证码",
    reg_email_code_hint: "请输入邮箱验证码",
    reg_email_code_hint1: "请输入邮箱验证码",
    reg_password: "设置密码",
    reg_password1: "设置密码",
    reg_password_hint: "请输入新密码",
    reg_password_hint1: "请设置密码",
    reg_password_hint2: "请设置密码",
    reg_password_hint_two: "密码由8位及以上大小写字母、数字组成",
    reg_confirm_password: "确认密码",
    reg_confirm_password_hint: "请再次确认密码",
    reg_confirm_password_hint1: "请再次输入密码",
    reg_confirm_password_hint_two: "密码和确认密码不一致",
    reg_go: "立即注册",
    reg_go1: "立即注册",
    reg_desc: "我已经看过并同意",
    reg_desc_two: "《用户协议》",
    reg_no_email: "没有邮箱？请使用手机号",
    reg_ister: "请使用邮箱",
    reg_ister_two: "请使用手机号",
    reg_no_email_hint: "为手机号",
    reg_no_phone: "没有手机号？请使用邮箱",
    reg_no_phone_hint: "注册",
    reg_pass_phone: "通过手机号注册",
    reg_pass_email: "通过邮箱注册",
    reg_success: "注册成功",
    reg_goLogin: "马上登录",
    reg_get_code: "获取短信验证码",
    reg_get_code1: "获取邮箱验证码",
    reg_get_code2: "获取邮箱验证码",
    reg_get_code_anew: "重新获取",
    reg_get_code_anew2: "重新获取",
    // =============================
    footer_icp: "京ICP备",
    footer_mun: "07035254号-1",
    footer_int: "京公网安备",
    footer_int_num: "11010102000192号",
    footer_desc: "出版物经营许可证",
    footer_info: "新出发京零字第东130025号",
    //================================================
    find_pass_phone: "通过手机号找回",
    find_pass_email: "通过邮箱找回",
    find_get_note_verification: "获取验证码",
    find_regain: "重新获取",
    find_PASSWORD: "密码",
    find_CONFIRM_PASSWORD: "确认密码",
    find_CONFIRM_PASSWORD_two: "再次输入密码",
    find_CONFIRM_PASSWORD_two1: "再次输入密码",
    find_RETRIEVE: "立即找回",
    find_Retrieve_password_via_phone: "通过手机号找回",
    find_Retrieve_password_via_Email: "通过邮箱找回",
    find_Password_Rese: "重置密码成功",
    find_LOFGIN_NOW: "马上登录",
    find_code_correct_hint: "请输入正确验证码",
    find_email_correct_hint: "请输入正确的邮箱",
    find_email_Registered_mail_true: "邮箱已经注册,可以直接登录", //The mailbox has been registered and can be directly logged in
    find_email_Registered_mail_false: "该邮箱未注册，请您先注册", //This mailbox is not registered, please register first
    find_email_authentication: "邮箱认证有效，注册成功后可通过该邮箱登录和找回密码", //*The mailbox authentication is valid. After successful registration, you can log in and retrieve the password through the mailbox
    find_input_account: "请输入账号",
    find_phone_Registered_mail_true: "手机号已注册,可以直接登录",
    find_phone_Registered_mail_false: "该手机号未注册，请您先注册",
    find_phone_authentication: "* 手机号认证有效，注册成功后可通过该手机登录和找回密码",
    find_password_success: "您已经成功设置密码",
    find_password_success_reset: "请使用新密码登录",
    find_over_login: "其他登录方式",
    find_phoneOremail: "手机号/邮箱",
    find_Login: "登录",
    find_Login1: "登录",
    find_input_phone_email: "请输入手机号/邮箱",
    find_input_pass: "请输入密码",
    find_code: "图片验证码",
    find_input_code: "请输入图片验证码",
    find_forget_pass: "忘记密码?",
    find_no_login_name: "没有账号?",
    find_auto_login: "下次自动登录",
    find_auto_ip_login: "IP自动登录",
    find_code_correct_phone: "请输入手机验证码",
    find_password_hint: "请设置您的密码",
    find_password_hint1: "请设置您的密码",
    find_register_success: "恭喜您注册中华医学期刊网",
    find_register_success_two: "成功",
    find_Account_problem: "账户问题请咨询",
    find_collecting_and_editing: "投审稿系统问题请咨询",
    find_full_text_database: "全文数据库问题请咨询",
    find_jiantou: ">>",
    find_Binding: "账号绑定",
    find_Binding_Liji: "立即绑定",
    // =============接口=============
    registerByPhone_info_one: "验证码已过期，请重新发送",
    registerByPhone_info_two: "验证码不一致，请重新输入",
    registerByPhone_info_three: "手机号已存在",
    registerByPhone_info_four: "图片验证码已过期，请重新获取图片验证码",
    registerByPhone_info_five: "图片验证码不正确，请重新输入",
    registerByPhone_info_six: "密码格式不正确，请重新输入",
    registerByEmail_info_one: "邮箱已存在",
    retrievePassByPhone_info_one: "新密码必须包含 大写字母 小写字母 数字最少8位",
    retrievePassByPhone_info_two: "手机号不存在",
    retrievePassByEmail_info_one: "邮箱不存在",
    registerByPhone_info_seven: 'IDS访问异常：手机号码已存在',
    //====================左侧部分================
    leftPhone1: '010-51322487',
    leftPhone2: '010-62956932',
    leftPhone3: '010-51322390/2391',
    find_Online:'在线咨询',
    testAndVerify:'请填写符合条件的手机号',
    testAndVerify1:'请填写符合条件的邮箱',
    
};
const en = {
    userName: "username",
    reg_phone: "PHONE NUMBER",
    reg_phone_hint: "Enter your phone number",
    reg_phone_hint_two: "Wrong phone number",
    reg_phone_hint_three: "Phone number has been registered you can login!",
    reg_phone_hint_four: "The phone number is valid. You can login or retrieve password via this phone number",
    reg_phone_hint_five: "Phone number is unregistered Please register first",
    reg_email: "EMAIL",
    reg_email_hint: "Enter your Email",
    reg_email_hint1: "Enter your Email",
    reg_email_hint_two: "Wrong Email",
    reg_email_hint_three: "Email has been registered you can login!",
    reg_email_hint_four: "The email address is valid. You can login or retrieve password via this email",
    reg_email_hint_five: "Email is unregistered Please register first",
    reg_code: "VERIFICATION CODE",
    reg_code_hint: "Retype the code in picture",
    reg_phone_code: "PHONE CONFIRMATION CODE",
    reg_phone_code_hint: "Phone confirmation code",
    reg_email_code: "EMAIL CONFIRMATION CODE",
    reg_email_code_hint: "Email confirmation code",
    reg_email_code_hint1: "Email confirmation code",
    reg_password: "PASSWORD",
    reg_password1: "NEW PASSWORD",
    reg_password_hint: "Enter your new password",
    reg_password_hint1: "Enter your new password",
    reg_password_hint2: "Enter your new password",
    reg_password_hint_two: "The password consists of 8 or more letters and digits",
    reg_confirm_password: "CONFIRM PASSWORD",
    reg_confirm_password_hint: "Enter password again",
    reg_confirm_password_hint1: "Enter password again",
    reg_confirm_password_hint_two: "Inconsistent passwords",
    reg_go: "HERE",
    reg_go1: "REGISTER",
    reg_desc: "I have read and agreed the ",
    reg_desc_two: "Usage Agreement",
    reg_no_email: "No Email?Use phone number to ",
    reg_ister: "please use",
    // reg_no_email_hint: "",
    reg_no_phone: "No phone number? Use Email to ",
    // reg_no_phone_hint: "",
    reg_pass_phone: "Register by phone number",
    reg_pass_email: "Register via email",
    reg_success: "Register successfully",
    reg_goLogin: "LOGIN NOW",
    reg_get_code: "Get Code",
    reg_get_code1: "Get Code",
    reg_get_code2: "Resend",
    reg_get_code_anew: "Resend after",
    reg_get_code_anew2: "Resend",
    footer_icp: "JING-ICP for",
    footer_mun: "No. 07035254-1",
    footer_int: "Jing Wan Secure",
    footer_int_num: "No. 11010102000192",
    footer_desc: "Publication Operation License",
    footer_info: "No. 130025 east, Jinglian Zi, New departure",
    //===========================================
    find_pass_phone: "Retrieve via Phone",
    find_pass_email: "Retrieve via Email",
    find_get_note_verification: "GET CODE",
    find_regain: "Resend",
    find_PASSWORD: "PASSWORD",
    find_CONFIRM_PASSWORD: "CONFIRM PASSWORD",
    find_CONFIRM_PASSWORD_two: "Enter your password again",
    find_CONFIRM_PASSWORD_two1: "Enter password again",
    find_RETRIEVE: "RETRIEVE",
    find_Retrieve_password_via_phone: "Retrieve password via phone",
    find_Retrieve_password_via_Email: "Retrieve password via email",
    find_Password_Rese: "Password Reset",
    find_LOFGIN_NOW: "LOGIN NOW",
    find_code_correct_hint: "Enter the correct verification code",
    find_email_correct_hint: "Enter the correct email address",
    find_email_Registered_mail_true: "The mailbox has been registered and can be directly logged in",
    find_email_Registered_mail_false: "Email does not exist",
    find_email_authentication: "The email address is valid. You can login or retrieve password via this email",
    find_input_account: "Please enter your account number",
    find_phone_Registered_mail_true: "The mobile phone number has been registered, you can directly log in",
    find_phone_Registered_mail_false: "Phone number does not exist",
    find_phone_authentication: "The phone number is valid. You can login or retrieve password via this phone number ",
    find_phone_success: "Congratulations！Password",
    find_password_success_reset: "Password Successfully reset",
    find_over_login: "Third-party login",
    find_phoneOremail: "EMAIL/PHONE NUMBER",
    find_Login: "LOGIN",
    find_Login1: "Login",
    find_input_phone_email: "Enter your Email/phone number",
    find_input_pass: "Enter your password ",
    find_code: "CONFIRMATION CODE",
    find_input_code: "Retype the code in picture",
    find_forget_pass: "Forget the password?",
    find_no_login_name: "Have no account?  Create one HERE",
    find_auto_login: "Remember me",
    find_auto_ip_login: "LOGIN via IP",
    find_code_correct_phone: "Phone confirmation code",
    find_password_hint: "Enter your password",
    find_password_hint1: 'Enter your new password',
    find_register_success: "Congraulations!",
    find_register_success_two: "You have registered in CMAPH network",
    find_Account_problem: "User account and consume",
    find_collecting_and_editing: "Submit a manuscript",
    find_full_text_database: "CMAPH journal database",
    find_jiantou: ">>",
    find_Binding: "Binding account",
    find_Binding_Liji: "BINDING",
    // =============接口=============
    registerByPhone_info_one: "Code has expired Please resend it",
    registerByPhone_info_two: "Wrong verification code",
    registerByPhone_info_three: "Mobile number exists",
    registerByPhone_info_four: "Code has expired Obtain the verification code again",
    registerByPhone_info_five: "Wrong verification code.",
    registerByPhone_info_six: "Password format is incorrect Please re-enter it",
    registerByEmail_info_one: "Mailbox exists",
    retrievePassByPhone_info_one: "The password consists of 8 or more letters and digits",
    retrievePassByPhone_info_two: "Phone number does not exist",
    retrievePassByEmail_info_one: "Mailbox does not exist",
    registerByPhone_info_seven: 'IDS access exception: mobile phone number already exists',
    //====================左侧部分================
    leftPhone1: '86(10)-51322462',
    leftPhone2: '86(10)-62956932',
    leftPhone3: '86(10)-51322390/2391',
    find_Online:'Online consultation',
    testAndVerify:'Please fill in the qualified mobile phone number.',
    testAndVerify1:'Please fill in the eligible email address.'
};

export default { zh, en };


// WEBPACK FOOTER //
// ./src/components/mobileLogin/language.js